import { ReactNode, useCallback, useState } from 'react'
import { StyleSheet } from 'react-native-unistyles'

import BillingMessage from '@/components/shared/BillingMessage'
import UniKeyboardAwareScrollView from '@/components/unistyles/UniKeyboardAwareScrollView'
import UniRefreshControl from '@/components/unistyles/UniRefreshControl'
import { KeyboardOffset } from '../../../constants'

interface Props {
  children: ReactNode
  onRefresh?: () => Promise<void>
  requiresSubscription?: boolean
  scrollRef?: React.RefObject<any>
  viewId: string
}

const Page = ({
  children,
  onRefresh,
  requiresSubscription = true,
  scrollRef,
  viewId,
}: Props) => {
  const [refreshing, setRefreshing] = useState(false)

  const doRefresh = useCallback(() => {
    setRefreshing(true)
    onRefresh?.()
      .then(() => setRefreshing(false))
      .catch(() => setRefreshing(false))
  }, [onRefresh])

  return (
    <UniKeyboardAwareScrollView
      bottomOffset={KeyboardOffset}
      contentContainerStyle={styles.container}
      contentInsetAdjustmentBehavior="automatic"
      nativeID={viewId}
      ref={scrollRef}
      refreshControl={
        onRefresh ? (
          <UniRefreshControl onRefresh={doRefresh} refreshing={refreshing} />
        ) : undefined
      }
      style={styles.scrollView}
    >
      <BillingMessage requiresSubscription={requiresSubscription} />
      {children}
    </UniKeyboardAwareScrollView>
  )
}

const styles = StyleSheet.create((theme) => ({
  container: {
    flexDirection: 'column',
    gap: theme.tokens.spacing[4],
    padding: theme.tokens.spacing[4],
    paddingBottom: theme.tokens.spacing[8],
  },
  scrollView: {
    flex: 1,
    minHeight: 0,
  },
}))

export default Page
